import { render, staticRenderFns } from "./ComponentWrapper.vue?vue&type=template&id=a4f8d6f6&scoped=true"
import script from "./ComponentWrapper.vue?vue&type=script&lang=js"
export * from "./ComponentWrapper.vue?vue&type=script&lang=js"
import style0 from "./ComponentWrapper.vue?vue&type=style&index=0&id=a4f8d6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f8d6f6",
  null
  
)

export default component.exports